import React from 'react'
import './css/nav.css'
// import { FaUser, FaBriefcase } from 'react-icons/fa'
// import { AiFillContacts } from 'react-icons/ai'
export default function Nav({ Link }) {
    return (
        <div className='side-bar'>
            <div className='side-box'>
                <h1 className='name'>Akash Kamat</h1>
                <ul className='nav-items'>
                    <li whileTap={{ scale: 0.9 }} whileHover={{ scale: 1.1, originX: 0 }} >
                        {/* <FaUser /> */}
                        <Link to="/about" className="nav-link" activeClassName="active" >About</Link>
                    </li>
                    <li whileTap={{ scale: 0.9 }} whileHover={{ scale: 1.1, originX: 0 }} >
                        {/* <FaBriefcase /> */}
                        <Link to="/works" className="nav-link" activeClassName="active" >Works</Link>
                    </li>
                    <li whileTap={{ scale: 0.9 }} whileHover={{ scale: 1.1, originX: 0 }} >
                        {/* <AiFillContacts /> */}
                        <Link to="/socials" className="nav-link" activeClassName="active" >Socials</Link>
                    </li>
                </ul>
            </div>
        </div>
    )
}
